module.exports = __webpack_public_path__ + "img/icon-compass.dd389873.svg";